import React from "react";

import { RouteErrorBoundary } from "src/components/ErrorBoundary/RouteErrorBoundary.tsx";

import { ModuleLayoutV2 } from "src/framework/layoutV2/ModuleLayoutV2.tsx";
import { queryClient } from "src/lib/react-query.tsx";

import { getClientConfig } from "src/client-config/getClientConfig.ts";
import { moduleTranslationsQuery } from "src/system/moduleTranslationsQuery.tsx";

export type CreateModuleLayoutV2Props = {
  resource: string;
};
export function createModuleLayoutV2({ resource }: CreateModuleLayoutV2Props) {
  const Component = () => {
    return <ModuleLayoutV2 resource={resource} />;
  };
  const ErrorBoundary = RouteErrorBoundary;
  const loader = async () => {
    const clientConfig = getClientConfig();
    if (!clientConfig) {
      // client config is not yet fetch
      // we can't prefetch module config yet
      return null;
    }
    // fetch in parallel
    await Promise.all([
      queryClient.ensureQueryData(
        moduleTranslationsQuery({
          resource,
        }),
      ),
    ]);

    return null;
  };
  return {
    Component,
    ErrorBoundary,
    loader,
  };
}
